import { useI18n } from '../i18n/context.js';
import { useSession } from '../state/session.js';
import { Icon } from './Icon.js';

/** Shown during Telegram auth boot, when outside Telegram, or on auth error. */
export function AuthScreen() {
  const { status, error, retry } = useSession();
  const { t } = useI18n();

  if (status === 'booting') {
    return (
      <div className="auth-screen">
        <div className="auth-inner fade-in">
          <span className="spinner" style={{ width: 36, height: 36 }} />
          <p className="auth-hint">{t('auth.loading')}</p>
        </div>
      </div>
    );
  }

  if (status === 'no-telegram') {
    return (
      <div className="auth-screen">
        <div className="auth-inner fade-in">
          <Icon name="alert" size={48} />
          <h1 className="auth-title">{t('auth.openInTelegram')}</h1>
          <p className="auth-hint">{t('auth.openInTelegramHint')}</p>
          <button type="button" className="btn btn-primary" onClick={retry}>
            {t('auth.retry')}
          </button>
          {import.meta.env.DEV && (
            <p className="auth-dev">{t('auth.devHint')}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="auth-screen">
      <div className="auth-inner fade-in">
        <Icon name="alert" size={48} />
        <h1 className="auth-title">{t('auth.error')}</h1>
        {error && <p className="auth-hint">{error}</p>}
        <button type="button" className="btn btn-primary" onClick={retry}>
          {t('auth.retry')}
        </button>
      </div>
    </div>
  );
}
